import { i18n } from "@/setup/i18n-setup";
import { IAvailableMongoViewColumn, MongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import { IDataTableColumn } from "winfakt-vue-components";

export enum MongoViewTypes {
	PRICE_LISTS = "price-lists"
}

export class MongoView {
	ID:number = 0;
	Type:string = MongoViewTypes.PRICE_LISTS;
	Name:string = i18n.t("common.new-view").toString();
	UserID:number = 0;
	SupplierNR:string = "";
	Columns:MongoViewColumn[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Type = data.Type;
		this.Name = data.Name;
		this.UserID = data.UserID;
		this.SupplierNR = data.SupplierNR || "";
		this.Columns = ((data.Columns || []) as any[]).map(d=>new MongoViewColumn(d));
	}

	public getJSON(){
		return {
			ID: this.ID,
			Type: this.Type,
			Name: this.Name.trim(),
			UserID: this.UserID,
			SupplierNR: this.SupplierNR,
			Columns: this.Columns
		};
	}

	public getDataTableCols(availableColumns:IAvailableMongoViewColumn[]):IDataTableColumn[] {
		return this.Columns.map(c=>c.toDataTableColumn(availableColumns));
	}
}
